import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { Cluster } from '../../sections/types/Cluster';

export interface IUpdateBaasClusterNameParams {
  clusterId: string;
  displayName: string;
}

export interface IUpdateBaasClusterNameResult extends IResult {
  success?: Cluster;
}

export class UpdateBaasClusterNameRequest extends Request<IUpdateBaasClusterNameParams, IUpdateBaasClusterNameResult> {
  constructor(params: IUpdateBaasClusterNameParams) {
    super('updateBaasClusterName', params);
  }
}
